const footerDropdowns = document.querySelectorAll('.js-footer-dropdown')

const cFooterInit = () => {

    footerDropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', function (e) {
            if(dropdown.classList.contains('active')){
                dropdown.classList.remove('active')
            }else{
                removeActive()
                dropdown.classList.add("active")
            }
        })
    })
}

const removeActive = () => {
    footerDropdowns.forEach(dropdown => {
        dropdown.classList.remove('active')
    })
}

export default cFooterInit
